export default "__VITE_ASSET__CiCb2gf4__";